'use client';
import { useState } from 'react';

const CallToActionContactForm = ({ formTitle = 'Contact Us', callToAction }) => {
  const [submitMessage, setSubmitMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    const form = e.target;
    const data = new FormData(form);

    if (
      !data.get('firstName').trim() ||
      !data.get('lastName').trim() ||
      !data.get('email').trim() ||
      !data.get('company').trim()
    ) {
      setSubmitMessage('Complete required fields');
      setTimeout(() => {
        setSubmitMessage(false);
      }, 5000);
      return;
    }

    try {
      const resp = await fetch('/contact-form.html', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(data).toString(),
      });

      if (resp.ok) {
        setSubmitMessage('Submitted!');
        form.reset();
      } else {
        setSubmitMessage('Failed');
      }
    } catch (err) {
      console.error('Network error', err);
      setSubmitMessage('Failed');
    }

    setTimeout(() => {
      setSubmitMessage(false);
    }, 5000);
  };

  return (
    <div className="flex w-full flex-col items-center gap-6 bg-white sm:gap-8 lg:gap-12">
      <h2 className="text-center text-2xl font-bold text-brittainRed uppercase sm:text-3xl md:text-4xl lg:text-largeh2">
        {formTitle}
      </h2>

      {callToAction && (
        <p className="mb-4 text-center text-lg sm:text-xl lg:max-w-4/5 lg:text-paragraphLarge">
          {callToAction}
        </p>
      )}

      <form
        name="get-started-form"
        method="POST"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        className="w-full space-y-6 lg:max-w-4/5"
        onSubmit={handleSubmit}
      >
        {/* Hidden field for Netlify */}
        <input type="hidden" name="form-name" value="get-started-form" />
        <div style={{ display: 'none' }}>
          <label htmlFor="bot-field">
            Don&apos;t fill this out if you&apos;re human:{' '}
            <input type="text" id="bot-field" name="bot-field" tabIndex={-1} aria-hidden="true" />
          </label>
        </div>
        {/* First Name */}
        <div className="flex flex-row items-center gap-2 sm:gap-4">
          <label
            htmlFor="firstName"
            className="w-24 text-left font-lato text-base font-medium text-black sm:text-right sm:text-lg xl:w-48 xl:text-xl"
          >
            First Name<span className="text-brittainRed">*</span>
          </label>
          <input
            type="text"
            id="firstName"
            name="firstName"
            required
            aria-required="true"
            className="flex-1 rounded-md border border-gray-300 bg-[#D9D9D9] px-3 py-2 text-lg text-black focus:border-transparent focus:ring-2 focus:ring-brittainRed focus:outline-none xl:text-xl"
          />
        </div>

        {/* Last Name */}
        <div className="flex flex-row items-center gap-2 sm:gap-4">
          <label
            htmlFor="lastName"
            className="w-24 text-left font-lato text-base font-medium text-black sm:text-right sm:text-lg xl:w-48 xl:text-xl"
          >
            Last Name<span className="text-brittainRed">*</span>
          </label>
          <input
            type="text"
            id="lastName"
            name="lastName"
            required
            aria-required="true"
            className="flex-1 rounded-md border border-gray-300 bg-[#D9D9D9] px-3 py-2 text-lg text-black focus:border-transparent focus:ring-2 focus:ring-brittainRed focus:outline-none xl:text-xl"
          />
        </div>

        {/* Email */}
        <div className="flex flex-row items-center gap-2 sm:gap-4">
          <label
            htmlFor="email"
            className="w-24 text-left font-lato text-base font-medium text-black sm:text-right sm:text-lg xl:w-48 xl:text-xl"
          >
            Email<span className="text-brittainRed">*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            required
            aria-required="true"
            className="flex-1 rounded-md border border-gray-300 bg-[#D9D9D9] px-3 py-2 text-lg text-black focus:border-transparent focus:ring-2 focus:ring-brittainRed focus:outline-none xl:text-xl"
          />
        </div>

        {/* Company */}
        <div className="flex flex-row items-center gap-2 sm:gap-4">
          <label
            htmlFor="company"
            className="w-24 text-left font-lato text-base font-medium text-black sm:text-right sm:text-lg xl:w-48 xl:text-xl"
          >
            Company<span className="text-brittainRed">*</span>
          </label>
          <input
            type="text"
            id="company"
            name="company"
            required
            aria-required="true"
            className="flex-1 rounded-md border border-gray-300 bg-[#D9D9D9] px-3 py-2 text-lg text-black focus:border-transparent focus:ring-2 focus:ring-brittainRed focus:outline-none xl:text-xl"
          />
        </div>

        {/* Submit Button */}
        <div className="flex justify-center pt-6 sm:pt-8">
          <button
            type="submit"
            disabled={submitMessage.length > 0}
            aria-label={submitMessage ? submitMessage : 'Submit contact form'}
            className={`w-50 cursor-pointer rounded-3xl bg-brittainRed py-2 font-lato text-lg font-extrabold tracking-wider text-white hover:scale-110 focus:ring-2 focus:ring-brittainRed focus:ring-offset-2 focus:outline-none md:w-56 md:py-3 md:text-xl ${submitMessage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'}`}
          >
            {submitMessage ? submitMessage : 'CONTACT US'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CallToActionContactForm;
